const TextInputEmail = ({ value, onChange }) => {
  return (
    <div>
      <label 
        className="block text-gray-700 mb-2" 
        htmlFor="email"
      >
        Email
      </label>
      <input
        type="email"
        id="email"
        name="email"
        value={value}
        onChange={onChange}
        placeholder="Masukkan alamat email Anda"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
        required
      />
    </div>
  )
}

export default TextInputEmail